import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const RecipientGroupSchema = BigdesDefinitionSchema.extend({});
export const CreateRecipientGroupSchema = RecipientGroupSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateRecipientGroupSchema = RecipientGroupSchema.partial();
